import { Data, PbCompanyInfo, Timestamp } from '@/connect';
import { AgreementInfo } from '@/modules/agreements/models';
import { CompanyInfo } from '@/modules/common/models';
import { formatAnyDate, ifTimestampToDate } from '@/utils/helpers/dates';
import Decimal from 'decimal.js';

export function formatAgreementInfoShort(agreementInfo?: AgreementInfo): string {
  return agreementInfo === undefined
    ? ''
    : agreementInfo.shortName
      ? agreementInfo.shortName
      : agreementInfo.id;
}

export function formatCompanyInfo(companyInfo?: Data<PbCompanyInfo> | CompanyInfo): string {
  return companyInfo === undefined ? '–' : `${companyInfo.displayId} – ${companyInfo.companyName}`;
}

export function formatString(value?: string): string {
  return value?.trim() || '–';
}

export function formatDecimal(value?: Decimal | string, decimalPlaces = 2): string {
  value = typeof value === 'string' ? new Decimal(value) : value;
  return value ? value.toFixed(decimalPlaces) : '–';
}

export function formatDecimalPercentage(value?: Decimal, decimalPlaces = 0): string {
  return value ? value.toFixed(decimalPlaces) + '%' : '–';
}

export function formatPercentCollateral(collateralRate: string): string {
  return formatDecimalPercentage(new Decimal(collateralRate));
}

export function formatTime(time?: Date | null | string): { time: string } {
  time = typeof time === 'string' ? new Date(time) : time;
  return { time: !time ? '–' : formatAnyDate(time, 'hh:mm a') };
}

export function formatDate(date?: Date | null | string): { date: string } {
  date = typeof date === 'string' ? new Date(date) : date;
  return { date: !date ? '–' : formatAnyDate(date, 'MMM dd') };
}

export function formatDateTimeObject(dateTime?: Date | null | undefined | string): {
  date: string;
  time: string;
} {
  dateTime = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;
  return !dateTime
    ? { date: '–', time: '' }
    : {
        ...formatDate(dateTime),
        ...formatTime(dateTime),
      };
}

export function formatDateTime(dateTime?: Date | null | string): string {
  const { date, time } = formatDateTimeObject(dateTime);
  return `${date} ${time}`;
}

export function formatTimestampObject(timestamp?: Data<Timestamp> | null): {
  date: string;
  time: string;
} {
  return formatDateTimeObject(ifTimestampToDate(timestamp));
}

export function formatTimestamp(timestamp?: Data<Timestamp> | string | null): string {
  const { date, time } = formatDateTimeObject(ifTimestampToDate(timestamp));
  return `${date} ${time}`;
}
